
import {
  mdiCheck,
  mdiCheckCircleOutline,
  mdiChevronLeft,
  mdiInformation,
  mdiLock,
  mdiRvTruck,
  mdiShieldCheckOutline,
  mdiStar,
  mdiTruckTrailer
} from '@mdi/js'
import { ValidationObserver, ValidationProvider } from 'vee-validate'

import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import freeEmailProviders from 'free-email-domains'
import ConfirmationDialog from '@/components/ad/edit/upload/attributes/ConfirmationDialog.vue'
import eav from '@/components/tools/eav'
import upload from '@/components/tools/upload'
import api from '@/components/tools/api'
import utils from '@/components/tools/utils'
import tracking from '@/components/tools/tracking'
import constants from '@/components/tools/constants'
import PhoneInput from '@/components/ui/PhoneInput.vue'

// import { viewport } from '@/plugins/viewport.client'
import LoginForm from '@/components/auth/LoginForm.vue'

export default {
  icons: {
    mdiCheck,
    mdiInformation,
    mdiRvTruck,
    mdiTruckTrailer,
    mdiShieldCheckOutline,
    mdiCheckCircleOutline,
    mdiLock,
    mdiStar,
    mdiChevronLeft
  },
  components: {
    LoginForm,
    PhoneInput,
    ConfirmationDialog,
    ValidationObserver,
    ValidationProvider
  },
  props: {
    defaultProductType: {
      type: String,
      default: undefined
    }
  },

  data () {
    return {
      step: 1,
      laborText: 'Analysiere Fahrzeugdaten...',
      submitting: false,
      confirmationDialog: {
        title: null,
        subtitle: null
      },
      loginOverlay: false,
      phoneNumberCountry: null,
      phoneErrors: [],
      phoneNumberInUse: false
    }
  },
  timeout: null,
  computed: {
    ...mapState({
      product: state => state.upload.product,
      productTypeOptionIds: state => state.upload.productTypeOptionIds,
      attributes: state => state.upload.attributes,
      attributesDe: state => state.upload.attributesDe,
      customer: state => state.customer.customer,
      customerAttributes: state => state.customer.customerAttributes
    }),
    ...mapGetters({ isNlDomain: 'isNlDomain' }),

    isSmallScreen () {
      return (this.$vuetify?.breakpoint?.height || 9999) <= 852
    },
    maxWidthPopupDialog () {
      if (this.$vuetify.breakpoint.mobile) {
        return '90wv'
      } else {
        return '600'
      }
    },

    showMake () {
      if (this.isSmallScreen) {
        return this.productTypeValue
      } else {
        return true
      }
    },
    showTrailerModel () {
      if (this.isSmallScreen) {
        return this.trailerMakeValue
      } else {
        return true
      }
    },
    showCategory () {
      if (this.isSmallScreen) {
        return this.makeValue
      }
      if (this.defaultProductType) {
        return true
      }
      return this.makeValue
    },

    entityId () {
      return this.product?.entityId
    },
    productType () {
      return this.productTypeValue?.optionId === this.productTypeOptionIds?.motorhome ? 'motorhome' : 'trailer'
    },
    submitEventWithPlannedDateOfSaleOptionForTracking () {
      const selectedOption = eav.getEavAttribute('planned_date_of_sale', this.product.attributes, this.attributes)
      const germanSelectOption = this.attributesDe?.planned_date_of_sale?.options.find(option => option.optionId === selectedOption?.optionId)

      return 'submit_vstepper_' + utils.getPlannedDateOfSaleOptionPrefixForTracking(germanSelectOption, this.productType)
    },

    submitEventWithPurposeOptionForTracking () {
      const selectedOption = eav.getEavAttribute('purpose', this.product.attributes, this.attributes)
      const germanSelectOption = this.attributesDe?.purpose?.options.find(option => option.optionId === selectedOption?.optionId)

      return 'submit_vstepper_' + utils.getPurposeOptionPrefixForTracking(germanSelectOption, this.productType)
    },
    cardStyle () {
      if (this.step === 1 && (this.isSmallScreen || this.defaultProductType)) {
        return 'min-height: 420px;'
      } else {
        return 'min-height: 500px;'
      }
    },
    numberOfSubmittedToday () {
      // generate a random numer between 82 and 142 for "this" day, store it in localStorgae and return it
      // ensure that it does not break ssr
      if (typeof window === 'undefined') {
        return 0
      }
      const today = new Date().toJSON().slice(0, 10).replace(/-/g, '_')
      const key = 'nos_' + today

      const storedValue = utils.safeLocalStorageGet(key)
      if (storedValue) {
        return parseInt(storedValue)
      } else {
        const randomValue = Math.floor(Math.random() * 60) + 82
        utils.safeLocalStorageSet(key, randomValue)
        return randomValue
      }
    },

    numberOfInterestedBuyersTodayForMake () {
      // generate a random numer between 82 and 142 for "this" day, store it in localStorgae and return it
      // ensure that it does not break ssr
      if (typeof window === 'undefined') {
        return 0
      }

      const today = new Date().toJSON().slice(0, 10).replace(/-/g, '_')
      const key = 'noib_' + today + this.makeValue?.optionId

      const storedValue = utils.safeLocalStorageGet(key)
      if (storedValue) {
        return parseInt(storedValue)
      } else {
        const randomValue = Math.floor(Math.random() * 6) + 10
        utils.safeLocalStorageSet(key, randomValue)
        return randomValue
      }
    },

    productTypeValue: {
      get () {
        return eav.getEavAttribute(
          'product_type',
          this.product.attributes,
          this.attributes
        )
      },
      set (value) {
        this.$store.commit('upload/setAttribute', {
          attributeCode: 'product_type',
          value
        })
      }
    },
    years () {
      const years = []
      for (let i = new Date().getFullYear(); i >= 1990; i--) {
        years.push(`${i}`)
      }
      return years
    },

    // same rules the ad edit form uses, so a thousands separator ('120.000') is
    // rejected here instead of being sent as a string the backend cannot read
    mileageRules () {
      return upload.attributeCodeToVeeValidateRule('mileage', true, true, this.product)
    },

    makeValue: {
      get () {
        return eav.getEavAttribute(
          'make',
          this.product.attributes,
          this.attributes
        )
      },
      set (value) {
        if (this.product.entityId === null) {
          this.$cookies.set('funnel_20_unsubmitted', -1)
        }

        this.$store.commit('upload/setAttribute', {
          attributeCode: 'make',
          value
        })

        if (this.entityId) {
          this.deleteAttributes({
            entityId: this.entityId,
            attributeCodes: ['category', 'series', 'model_select', 'model', 'chassis_select']
          })

          this.clearProductTypeAttributes('trailer')
        }
      }
    },
    trailerMakeValue: {
      get () {
        return eav.getEavAttribute(
          'trailer_make',
          this.product.attributes,
          this.attributes
        )
      },
      set (value) {
        this.$store.commit('upload/setAttribute', {
          attributeCode: 'trailer_make',
          value
        })

        if (this.entityId) {
          this.deleteAttributes({
            entityId: this.entityId,
            attributeCodes: ['trailer_model', 'first_registration_year_hint']
          })
          this.clearProductTypeAttributes('motorhome')
        }
      }
    },
    trailerModelValue: {
      get () {
        return eav.getEavAttribute(
          'trailer_model',
          this.product.attributes,
          this.attributes
        )
      },
      set (value) {
        this.$store.commit('upload/setAttribute', {
          attributeCode: 'trailer_model',
          value
        })

        if (this.entityId) {
          this.deleteAttributes({
            entityId: this.entityId,
            attributeCodes: [
              'first_registration_year_hint',
              'category', 'series', 'model_select', 'model', 'chassis_select']
          })
        }
      }
    },
    categoryValue: {
      get () {
        return eav.getEavAttribute(
          'category',
          this.product.attributes,
          this.attributes
        )
      },
      set (value) {
        this.$store.commit('upload/setAttribute', {
          attributeCode: 'category',
          value
        })

        if (this.entityId) {
          this.deleteAttributes({
            entityId: this.entityId,
            attributeCodes: ['series', 'model_select', 'model', 'chassis_select']
          })
        }
      }
    },
    seriesValue: {
      get () {
        return eav.getEavAttribute(
          'series',
          this.product.attributes,
          this.attributes
        )
      },
      set (value) {
        this.$store.commit('upload/setAttribute', {
          attributeCode: 'series',
          value
        })

        if (this.entityId) {
          this.deleteAttributes({
            entityId: this.entityId,
            attributeCodes: ['model_select', 'model', 'chassis_select']
          })
        }
      }
    },
    modelSelectValue: {
      get () {
        return eav.getEavAttribute(
          'model_select',
          this.product.attributes,
          this.attributes
        )
      },
      set (value) {
        this.$store.commit('upload/setAttribute', {
          attributeCode: 'model_select',
          value
        })

        if (this.entityId) {
          this.deleteAttributes({
            entityId: this.entityId,
            attributeCodes: ['model', 'chassis_select']
          })
        }
      }
    },
    modelValue: {
      get () {
        return eav.getEavAttribute(
          'model',
          this.product.attributes,
          this.attributes
        )
      },
      set (value) {
        this.$store.commit('upload/setAttribute', {
          attributeCode: 'model',
          value
        })
        if (this.entityId) {
          this.deleteAttributes({
            entityId: this.entityId,
            attributeCodes: ['chassis_select']
          })
        }
      }
    },

    chassisSelectValue: {
      get () {
        return eav.getEavAttribute(
          'chassis_select',
          this.product.attributes,
          this.attributes
        )
      },
      set (value) {
        this.$store.commit('upload/setAttribute', {
          attributeCode: 'chassis_select',
          value
        })
        if (this.entityId) {
          this.deleteAttributes({
            entityId: this.entityId,
            attributeCodes: ['power_select', 'power', 'engine_capacity_select', 'engine_capacity']
          })
        }
      }
    },

    mileageValue: {
      get () {
        return eav.getEavAttribute(
          'mileage',
          this.product.attributes,
          this.attributes
        )
      },
      set (value) {
        this.$store.commit('upload/setAttribute', {
          attributeCode: 'mileage',
          value
        })
      }
    },

    firstRegistrationYearValue: {
      get () {
        const firstRegistration = eav.getEavAttribute(
          'first_registration',
          this.product.attributes,
          this.attributes
        )
        if (firstRegistration) {
          return firstRegistration.split('-')[0]
        } else {
          return eav.getEavAttribute(
            'first_registration_year_hint',
            this.product.attributes,
            this.attributes
          )
        }
      },
      set (value) {
        // console.log('Setting first registration year hint:', value)
        this.$store.commit('upload/setAttribute', {
          attributeCode: 'first_registration_year_hint',
          value
        })
      }
    },

    powerSelectValue: {
      get () {
        return eav.getEavAttribute(
          'power_select',
          this.product.attributes,
          this.attributes
        )
      },
      set (value) {
        this.$store.commit('upload/setAttribute', {
          attributeCode: 'power_select',
          value
        })
      }
    },
    transmissionValue: {
      get () {
        return eav.getEavAttribute(
          'transmission',
          this.product.attributes,
          this.attributes
        )
      },
      set (value) {
        this.$store.commit('upload/setAttribute', {
          attributeCode: 'transmission',
          value
        })
      }
    },
    smokersCarValue: {
      get () {
        return eav.getEavAttribute(
          'smokers_car',
          this.product.attributes,
          this.attributes
        )
      },
      set (value) {
        this.$store.commit('upload/setAttribute', {
          attributeCode: 'smokers_car',
          value
        })
      }
    },

    damagedValue: {
      get () {
        return eav.getEavAttribute(
          'damaged',
          this.product.attributes,
          this.attributes
        )
      },
      set (value) {
        this.$store.commit('upload/setAttribute', {
          attributeCode: 'damaged',
          value
        })
      }
    },

    trailerDamagedValue: {
      get () {
        return eav.getEavAttribute(
          'trailer_damaged',
          this.product.attributes,
          this.attributes
        )
      },
      set (value) {
        this.$store.commit('upload/setAttribute', {
          attributeCode: 'trailer_damaged',
          value
        })
      }
    },

    trailerRentalValue: {
      get () {
        return eav.getEavAttribute(
          'trailer_rental',
          this.product.attributes,
          this.attributes
        )
      },
      set (value) {
        this.$store.commit('upload/setAttribute', {
          attributeCode: 'trailer_rental',
          value
        })
      }
    },

    trailerHailDamagedValue: {
      get () {
        return eav.getEavAttribute(
          'trailer_hail_damaged',
          this.product.attributes,
          this.attributes
        )
      },
      set (value) {
        this.$store.commit('upload/setAttribute', {
          attributeCode: 'trailer_hail_damaged',
          value
        })
      }
    },
    trailerWaterDamagedValue: {
      get () {
        return eav.getEavAttribute(
          'trailer_water_damaged',
          this.product.attributes,
          this.attributes
        )
      },
      set (value) {
        this.$store.commit('upload/setAttribute', {
          attributeCode: 'trailer_water_damaged',
          value
        })
      }
    },
    trailerSmokersCarValue: {
      get () {
        return eav.getEavAttribute(
          'trailer_smokers_car',
          this.product.attributes,
          this.attributes
        )
      },
      set (value) {
        this.$store.commit('upload/setAttribute', {
          attributeCode: 'trailer_smokers_car',
          value
        })
      }
    },

    trailerAnimalsCarValue: {
      get () {
        return eav.getEavAttribute(
          'trailer_animals_car',
          this.product.attributes,
          this.attributes
        )
      },
      set (value) {
        this.$store.commit('upload/setAttribute', {
          attributeCode: 'trailer_animals_car',
          value
        })
      }
    },

    plannedDateOfSaleValue: {
      get () {
        return eav.getEavAttribute(
          'planned_date_of_sale',
          this.product.attributes,
          this.attributes
        )
      },
      set (value) {
        this.$store.commit('upload/setAttribute', {
          attributeCode: 'planned_date_of_sale',
          value
        })
      }
    },
    purposeValue: {
      get () {
        return eav.getEavAttribute(
          'purpose',
          this.product.attributes,
          this.attributes
        )
      },
      set (value) {
        this.$store.commit('upload/setAttribute', {
          attributeCode: 'purpose',
          value
        })

        const germanSelectOption = this.attributesDe?.purpose?.options.find(option => option.optionId === value)

        if (germanSelectOption?.label?.toLowerCase().includes('ermitteln')) {
          const germanSelectOption = this.attributesDe?.planned_date_of_sale?.options.find(option => option.label?.toLowerCase().includes('monat'))
          // console.log('Automatically setting planned date of sale to:', germanSelectOption)
          this.$store.commit('upload/setAttribute', {
            attributeCode: 'planned_date_of_sale',
            value: germanSelectOption?.optionId
          })
        } else if (germanSelectOption?.label?.toLowerCase().includes('verkaufen')) {
          this.deleteAttributeByCode({
            entityId: this.entityId,
            attributeCode: 'planned_date_of_sale'
          })
          this.$store.commit('upload/unsetAttribute',
            'planned_date_of_sale'
          )
        }
      }
    },

    purposeValueIsSellOrValuation () {
      if (this.purposeValue) {
        const germanSelectOption = this.attributesDe?.purpose?.options.find(option => option.optionId === this.purposeValue?.optionId)
        if (germanSelectOption?.label?.toLowerCase().includes('verkaufen')) {
          return true
        } else if (germanSelectOption?.label?.toLowerCase().includes('ermitteln')) {
          return false
        }
      }

      return null
    },

    phone: {
      get () {
        return eav.getEavAttribute(
          'customer_phone',
          this.customer.attributes,
          this.customerAttributes
        )
      },
      set (value) {
        this.$store.commit('customer/setCustomerAttribute', {
          attributeCode: 'customer_phone',
          value
        })
      }
    },

    emailLabel () {
      return this.$t('email')
    },
    emailHint () {
      const { email } = this.customer
      const provider = email?.split('@')[1]
      const providerDomain = provider?.split('.')[1]

      if (
        !providerDomain ||
        providerDomain.length < 2 ||
        freeEmailProviders.includes(provider)
      ) {
        return
      }

      return this.$t('validation.email_provider', { _value_: email })
    },

    plannedDateOfSaleItems () {
      const excludedSelectOptions = this.attributesDe?.planned_date_of_sale?.options.filter(option => option?.label.toLowerCase().includes('trans') ||
        option?.label.toLowerCase().includes('kein')
      ).map(option => option.optionId)

      return this.attributes.planned_date_of_sale?.options
        .filter(
          option =>
            !excludedSelectOptions.includes(option.optionId)
        )
    },

    purposeItems () {
      return this.attributes.purpose?.options
    },

    smokersCarItems () {
      return this.attributes.smokers_car?.options
    },

    damagedItems () {
      return this.attributes.damaged?.options
    },

    productTypeItems () {
      return this.attributes.product_type?.options
    },

    makeItems () {
      return this.attributes.make?.options
        .filter(option =>
          !utils.isMakeBlacklisted(option.label))
    },
    trailerMakeItems () {
      return this.attributes.trailer_make?.options
        .filter(option =>
          !utils.isTrailerMakeBlacklisted(option.label))
    },

    categoryItems () {
      return this.attributes.category?.options
    },

    seriesItems () {
      return this.attributes.series?.options
    },

    modelSelectItems () {
      return this.attributes.model_select?.options
    },
    chassisSelectItems () {
      return this.attributes.chassis_select?.options
    },

    powerSelectItems () {
      return this.attributes.power_select?.options
        .slice().map(
          (option) => {
            if (option.label === 'Andere' || option.label === 'Unbekannt' || option.label === 'Onbekend') {
              return option
            }

            return {
              label: this.$eavFormatter.withUnit('power_select', option.label),
              optionId: option.optionId,
              sortOrder: option.sortOrder
            }
          }
        )
    },
    transmissionItems () {
      return this.attributes.transmission?.options
    },

    progressValue () {
      if (this.step === 1) {
        return 33
      }
      if (this.step === 2) {
        return 66
      }
      return 100
    },

    showSeries () {
      return this.makeValue && this.categoryValue && this.attributes.series
    },
    showModelSelect () {
      return this.showSeries && this.seriesValue && this.attributes.model_select
    },
    showModel () {
      return this.attributes.model && this.categoryValue
    },

    showChassis () {
      return (this.showModelSelect && this.modelSelectValue) || (this.showModel && this.modelValue)
    },
    sourceStepper () {
      return this.$route.path?.includes('-1') ? 'my_ads' : 'lp_sell_online'
    }
  },

  mounted () {
    if (this.defaultProductType) {
      if (this.defaultProductType === 'motorhome') {
        this.productTypeValue = { optionId: this.productTypeOptionIds?.motorhome }
      } else if (this.defaultProductType === 'trailer') {
        this.productTypeValue = { optionId: this.productTypeOptionIds?.trailer }
      }
    }

    this.$nextTick(() => {
      this.activateFurthestStep()
      this.loadEmailFromCookie()
      this.loadPhoneFromCookie()
    })
  },
  methods: {
    ...mapActions('upload', [
      'getProduct',
      'getProductTypeOptionIds',
      'getEmptyProduct',
      'getAttributes',
      'getAttributesDe',
      'updateProduct',
      'postGetConditionallyRequiredAttributes',
      'deleteAttributes',
      'deleteAttributeByCode'
    ]),
    ...mapActions('customer', ['getCustomer']),
    ...mapMutations('customer', ['sanitizeEmail', 'setSimpleCustomerAttribute']),
    ...mapActions('general', ['showSnackbar']),

    async clearProductTypeAttributes (productType) {
      const url = this.$auth.loggedIn
        ? `/private/product/clear-product-type-attributes/${this.entityId}/${productType}`
        : `/public/product/clear-product-type-attributes/${this.entityId}/${productType}`

      await this.$axios.delete(
        url, {
          withCredentials: true
        }, {}
      )
      if (this.entityId) {
        await this.getProduct(this.entityId)
      }
    },
    async requestAttributeConfirmation (attributeCode, value) {
      if (utils.shouldShowAttributeSaveConfirmation(attributeCode, value)) {
        // console.log(`Requesting confirmation for attribute ${attributeCode} with value ${value}`)
        this.confirmationDialog = {
          title: `${
            this.attributes[attributeCode].label
          }: ${this.$eavFormatter.formatUploadAttribute(attributeCode, value)}`,
          subtitle: utils.getAttributeSaveConfirmationSubtitle(
            attributeCode,
            this
          )
        }
        const confirmation =
          await this.$refs.confirmationDialog.requestConfirmation()

        return confirmation
      }

      return true
    },
    attributeCodeAppend (attributeCode, value) {
      const append = this.$eavFormatter.withUnit(attributeCode,
        (attributeCode === 'power' || attributeCode === 'power_select') && value ? value : '')

      if (append && append !== '') {
        return append
      }
      return undefined
    },
    async setProductType (productType, validate) {
      this.productTypeValue = {
        optionId: productType
      }

      if (validate) {
        await validate(productType)
      }

      if (this.product.entityId === null) {
        this.$cookies.set('funnel_20_unsubmitted', -1)
      }

      await this.safeProductUpdate()
      this.$cookies.set('funnel_20_unsubmitted', this.product.entityId)

      this.$refs.productTypeProvider.reset()
    },

    getValueForConfirmation (attributeCode, optionId) {
      try {
        const attr = this.attributes[attributeCode]
        if (attr.frontendInput === 'simple') {
          return optionId
        }

        return this.attributes[attributeCode]?.options?.find(o => o.optionId === optionId)
      } catch (e) {
        console.error(e)
      }
    },

    // @change fires regardless of the validation state, so an unusable mileage
    // would still be PUT and take the whole update down with a 400
    async onMileageChange (value) {
      const { valid } = await this.$refs.mileageProvider.validate(value)

      if (!valid) {
        return
      }

      await this.safeProductUpdate('mileage', value)
    },

    async safeProductUpdate (attributeCode, optionId) {
      // console.log(`safeProductUpdate called with attributeCode: ${attributeCode} and optionId: ${optionId}`)

      if (
        // this.attributes[attributeCode]?.frontendInput !== 'simple' &&
        attributeCode &&
        optionId) {
        const value = this.getValueForConfirmation(attributeCode, optionId)
        if (value) {
          // console.log('execute confirmation for attribute:', attributeCode)
          const confirmation = await this.requestAttributeConfirmation(
            attributeCode,
            value
          )

          if (!confirmation) {
            // console.log('confirmation failed for attribute:', attributeCode)

            this.$store.commit('upload/setAttribute', {
              attributeCode,
              value: null
            })
            return
          }
        }
      }

      await utils.initCm24UuidFromClientSide(this)

      if (this.product.entityId === null) {
        this.$cookies.set('funnel_20_unsubmitted', -1)
      }

      if (this.product.entityId === null) {
        const { data, joinedInFlightCreate } = await this.$store.dispatch('upload/createProduct', {
          source: tracking.getSource(this.source, this.$route),
          sourceUrl: this.$route.path,
          funnel: constants.TP.FUNNEL.VSTEPPER
        })

        this.$cookies.set('funnel_20_unsubmitted', data.entityId)

        // a change made while the create was running is already on the new ad
        // (the store pushed it), and the ad was logged by the call that created it
        if (joinedInFlightCreate) {
          return
        }

        await this.$store.dispatch('useractionlog/collect', {
          action: 'create_ad',
          that: this,
          productEntityId: data.entityId
        })

        return
      }

      await this.$store.dispatch('upload/updateProduct', {
        entityId: this.product.entityId
      })

      await this.$store.dispatch('useractionlog/collect', {
        action: 'update_ad',
        that: this,
        productEntityId: this.product.entityId
      })
      await this.postGetConditionallyRequiredAttributes()
    },
    goBack () {
      if (this.step === 4) {
        this.step = 2
      } else {
        this.step--
      }
    },
    activateFurthestStep () {
      if (this.productTypeValue?.optionId === this.productTypeOptionIds?.motorhome) {
        if ((this.makeValue && this.categoryValue && this.seriesValue && this.modelSelectValue && this.chassisSelectValue) ||
          (this.makeValue && this.categoryValue && this.modelValue && this.chassisSelectValue)
        ) {
          if (this.mileageValue && this.firstRegistrationYearValue && this.powerSelectValue && this.transmissionValue && this.smokersCarValue && this.damagedValue) {
            this.step = 4
          } else {
            this.step = 2
          }
        }
      } else if (this.productTypeValue?.optionId === this.productTypeOptionIds?.trailer) {
        if ((this.trailerMakeValue && this.trailerModelValue && this.firstRegistrationYearValue)) {
          if (this.mileageValue && this.trailerDamagedValue && this.trailerRentalValue && this.trailerHailDamagedValue && this.trailerWaterDamagedValue && this.trailerSmokersCarValue && this.trailerAnimalsCarValue) {
            this.step = 4
          } else {
            this.step = 2
          }
        }
      }
    },

    async goToStep (s, observer) {
      const valid = await observer.validate()

      if (valid) {
        this.step = s
      }

      if (this.step === 3) {
        this.startLaborIllusion()
      }
      this.scrollToStepperTop()
    },

    startLaborIllusion () {
      this.laborText = this.$t('landing.onboarding.labor_text_1')

      setTimeout(() => {
        this.laborText = this.$t('landing.onboarding.labor_text_2')
      }, 1000)

      const noib = this.numberOfInterestedBuyersTodayForMake

      setTimeout(() => {
        this.laborText = this.$t('landing.onboarding.labor_text_3', [noib])
      }, 2200)

      setTimeout(() => {
        this.step = 4
      }, 3000)
    },
    getCsrfToken () {
      return api.getCsrfToken(this)
    },
    doesUserExist () {
      return this.getCsrfToken().then(response =>
        this.$axios.$post(
          '/public/customer/auth/user',
          { email: this.customer.email },
          {
            withCredentials: true,
            headers: {
              'X-Csrf-Token': response.csrfToken,
              'X-Session-Id': response.sessionId
            }
          }
        ))
    },
    async maybeLoginAndSubmit (observer) {
      if (observer) {
        const valid = await observer.validate()
        if (!valid) {
          return
        }
      }

      if (this.$auth.loggedIn) {
        await this.submit()
        return
      }

      this.sanitizeEmail()
      const userExists = await this.doesUserExist()
      if (userExists) {
        this.loginOverlay = true
        return
      }

      const phoneValid = await this.checkPhoneBeforeSubmit()
      // console.log('phoneValid', phoneValid)
      if (!phoneValid) {
        return
      }

      await this.submit()
    },

    async checkPhoneBeforeSubmit (quick = false) {
      if (this.phone?.length > 0) {
        const result = utils.normalizePhone(this.phone, this.phoneNumberCountry)
        if (!result?.isMobile) {
          this.phoneErrors = [this.$t('landing.onboarding.phone_number_is_not_a_valid_mobile_number')]
          return false
        }

        if (quick) {
          return true
        }

        const { data: canUse } = await this.$axios.post('/public/signup/phone-verification/can-use', {
          phoneNumber: this.phone
        }, {
          withCredentials: true
        })
        if (!canUse) {
          this.phoneErrors = [this.$t('landing.onboarding.phone_number_already_in_use')]
          this.phoneNumberInUse = true
          return false
        }
      }
      return true
    },

    async submit () {
      this.submitting = true

      try {
        const sourceStepper = this.sourceStepper
        const { data } = await this.$axios.post(
          '/public/product/onboarding-stepper/submit-step-1',
          {
            productDto: this.product,
            customerDto: this.customer
          },
          {
            params: {
              productType: this.productType,
              source: sourceStepper
            }
          }
        )

        // const productType = data.productType
        this.$cookies.set('funnel_20_submitted_step_1', data.entityId)

        const customerData = {
          customerId: data.customerId,
          customerEmail: this.customer.email
        }

        this.$gtm.push(customerData)

        this.$gtm.push({
          event: 'submit_vstepper',
          auctionId: data.auction.auctionId,
          productId: data.entityId,
          currency: 'EUR',
          transaction_id: data.auction.auctionId + '_enter_public_ad_intake_with_email'
        })

        this.$gtm.push({
          event: this.submitEventWithPurposeOptionForTracking,
          auctionId: data.auction.auctionId,
          productId: data.entityId,
          transaction_id: data.auction.auctionId + '_' + this.submitEventWithPurposeOptionForTracking
        })
        try {
          if (this.$auth.loggedIn) {
            await this.getCustomer()
          } else {
            await this.$store.dispatch('customer/getOwner', data.entityId)
          }

          await this.redirectToAdIntakeAndClearStepperCookies()
        } catch (e) {
          console.error('Error fetching customer data:', e)
        }
      } catch (e) {
        if (e.response?.status === 409) {
          await this.showSnackbar({
            text: 'E-Mail Adresse bereits in Verwendung ... Bitte loggen sie sich ein um fortzufahren oder verwenden Sie eine andere E-Mail Adresse',
            color: 'error'
          })
        } else {
          await this.showSnackbar({
            text: 'Es gab ein Problem beim speichern der Daten. Bitte versuchen Sie es erneut oder wenden Sie sich an das Support Team von caravanmarkt24.de',
            color: 'error'
          })
        }

        this.submitting = false
      }
    },

    async redirectToAdIntakeAndClearStepperCookies () {
      const {
        productType,
        entityId
      } = this.product

      await this.$router.push(
        this.localePath({
          name: `ad-edit-${productType}-profile-id`,
          params: { id: entityId }
        })
      )

      await this.clearStepperCookies(entityId)
    },

    async clearStepperCookies (entityId) {
      await this.$store.dispatch('useractionlog/collect', {
        action: 'submit_vstepper',
        that: this,
        productEntityId: entityId
      })

      setTimeout(() => {
        this.$cookies.remove('funnel_20_unsubmitted')
      }, 3000)
    },

    scrollToStepperTop () {
      try {
        this.$nextTick(() => {
          // vee-validate v3 attaches aria-invalid on invalid inputs
          const el =
            // document.querySelector('[aria-invalid="true"]') ||
            document.querySelector('#stepper-top') // fallback

          if (!el) {
            window.scrollTo({
              top: 0,
              behavior: 'smooth'
            })
            return
          }

          el.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          })
        })
      } catch (e) {
        console.error(e)
      }
    },
    storeEmailInCookie () {
      try {
        if (this.customer.email) {
          this.$cookies.set('vstepper_email', this.customer.email)
        }
      } catch (e) {
        console.error(e)
      }
    },
    async storePhoneInCookie () {
      try {
        if (this.phone) {
          const success = await this.checkPhoneBeforeSubmit()
          if (success) {
            this.$cookies.set('vstepper_phone', this.phone)
          }
        }
      } catch (e) {
        console.error(e)
      }
    },
    loadEmailFromCookie () {
      try {
        const email = this.$cookies.get('vstepper_email')
        if (email && !this.customer.email) {
          this.setSimpleCustomerAttribute({
            key: 'email',
            value: email
          })
        }
      } catch (e) {
        console.error(e)
      }
    },
    loadPhoneFromCookie () {
      try {
        const phone = this.$cookies.get('vstepper_phone')
        if (phone && !this.phone) {
          this.$store.commit('customer/setCustomerAttribute', {
            attributeCode: 'customer_phone',
            value: phone
          })
        }
      } catch (e) {
        console.error(e)
      }
    },
    phoneNumberUpdated (number) {
      this.phoneErrors = []
      this.clearTimeoutIfExist()
      this.$options.timeout = setTimeout(() => {
        this.checkPhoneBeforeSubmit(true)
      }, 1000)
    },
    clearTimeoutIfExist () {
      if (this.$options.timeout) {
        // console.log('clearing timeout')
        clearTimeout(this.$options.timeout)
      }
    }
  }
}
